import React, { useId } from 'react';

interface SeperatorProps {
  className?: string;
  stopColor?: string;
  width?: number;
  height?: number;
}

const SeperatorIcon = function SeperatorIcon({
  className,
  stopColor,
  width,
  height,
}: SeperatorProps): JSX.Element {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 187 1"
    >
      <line y1="0.5" x2="187" y2="0.5" stroke={`url(#${id})`} />
      <defs>
        <radialGradient id={`${id}`} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(92.9995 1.00034) rotate(-180) scale(70.4995 13183.4)">
          <stop stopColor={stopColor} />
          <stop offset="1" stopColor={stopColor} stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

SeperatorIcon.defaultProps = {
  className: '',
  width: 187,
  height: 1,
  stopColor: '#D9D9D9',
};

export default SeperatorIcon;
